import { Configuration } from '@axelity/actasign-sic'

export interface EmailLinkSettingResponse {
  emailLinkDisabled?: boolean
}

export interface UpdateEmailLinkSettingRequest {
  emailLinkDisabled: boolean
}

/**
 * Get the current email link setting for an account
 * @param accountId - The MongoDB ObjectId of the account
 * @returns Promise with the email link setting
 */
export const getEmailLinkSetting = async (accountId: string): Promise<EmailLinkSettingResponse> => {
  const response = await fetch(`${Configuration.BASE_URL}/accounts/${accountId}/settings/email-link`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${Configuration.ACCESS_TOKEN}`,
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    const errorData = await response.json()
    throw new Error(errorData.title || 'Failed to fetch email link setting')
  }

  return response.json()
}

/**
 * Update the email link setting for an account
 * @param accountId - The MongoDB ObjectId of the account
 * @param emailLinkDisabled - Whether email links should be disabled
 * @returns Promise that resolves when update is complete
 */
export const updateEmailLinkSetting = async (
  accountId: string,
  emailLinkDisabled: boolean,
): Promise<void> => {
  const response = await fetch(`${Configuration.BASE_URL}/accounts/${accountId}/settings/email-link`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${Configuration.ACCESS_TOKEN}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ emailLinkDisabled }),
  })

  if (!response.ok) {
    const errorData = await response.json()
    throw new Error(errorData.title || 'Failed to update email link setting')
  }

  // 204 No Content - no response body
}
